import MergeRequestStore from 'ee/vue_merge_request_widget/stores/mr_widget_store';

export default MergeRequestStore;
